import {
  FormHelperText,
  FormLabel,
  Stack,
  StackProps,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButtonProps,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';

export type FormSelectProps = {
  control: Control<any>;
  name: string;
  label: string;
  options: ToggleButtonProps[];
  toggleButtonGroupProps?: Partial<ToggleButtonGroupProps>;
} & StackProps;
export const FormButtonToggleGroup = ({
  control,
  name,
  label,
  options,
  toggleButtonGroupProps,
  ...stackProps
}: FormSelectProps) => {
  const resolveErrorMessage = useErrorMessageResolver();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <Stack flex={1} spacing={1} {...stackProps}>
          <FormLabel error={!!error}>{label}</FormLabel>
          <ToggleButtonGroup
            {...field}
            onChange={(_, val) => field.onChange(val)}
            exclusive={true}
            fullWidth
            {...toggleButtonGroupProps}
          >
            {options.map(({ sx, children, ...rest }, i) => (
              <ToggleButton key={i} {...rest} sx={{ borderColor: error ? 'error.main' : undefined, ...sx }}>
                {children}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <FormHelperText error={!!error}>{resolveErrorMessage(error?.message) ?? 'test'}</FormHelperText>
        </Stack>
      )}
    />
  );
};
